import State from '../interfaces/states/CommentsState';

import * as Const from '../constants';

const initState: State = {
  commentData: {
    data: [],
  },
  disabled: false,
  isLoading: false,
  isError: false,
  hideNewComment: false,
  textAreaValue: '',
  isErrorSend: false,
  isLoadingSend: false,
};

export default function comments (state: State = initState, action): State {
  switch (action.type) {

    case Const.FETCH_COMMENTS_INIT:
      return {
        ...initState,
        isLoading: false,
      };

    case Const.FETCH_COMMENTS_PENDING:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };

    case Const.FETCH_COMMENTS_SUCCESS:
      return {
        ...state,
        commentData: {
          results: action.payload,
        },
        isLoading: false,
        isError: false,
        textAreaValue: '',
      };

    case Const.FETCH_COMMENTS_FAIL:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };

    case Const.FETCH_COMMENTS_BAR_HIDE:
      return {
        ...state,
        isLoading: false,
        isError: false,
        hideNewComment: false,
      };

    case Const.FETCH_COMMENTS_BAR_SHOW:
      return {
        ...state,
        isLoading: false,
        isError: false,
        hideNewComment: true,
      };

    case Const.FETCH_COMMENTS_VALUE:
      return {
        ...state,
        textAreaValue: action.payload,
      };

    case Const.FETCH_SEND_COMMENTS_PENDING:
      return {
        ...state,
        isLoadingSend: true,
        isErrorSend: false,
      };

    case Const.FETCH_SEND_COMMENTS_SUCCESS:
      return {
        ...state,
        isLoadingSend: false,
        isErrorSend: false,
        textAreaValue: '',
        // commentData: {
        //   data: [...state.commentData.data, action.payload]}
      };

    case Const.FETCH_SEND_COMMENTS_FAIL:
      return {
        ...state,
        isLoadingSend: false,
        isErrorSend: true,
      };

    default:
      return state;
  }
}
